import { todo, todoVariables } from "../rest-api/queries/types/todo"
import { GET_TODOS, GET_TODO } from "../rest-api/queries/todo"

import {
  CREATE_TODO,
  DELETE_TODO,
  UPDATE_TODO,
} from "../rest-api/mutations/todo"

import { useMutation, useQuery } from "@tanstack/react-query"

export default function useTodo(id: number) {
  const todos = useQuery(["GET_TODOS", id], () => GET_TODOS(id), {
    // enabled: !!id
    // variables: {
    //   first: 50,
    //   where: {
    //     sectionId: id,
    //   },
    // },
  })
  const todo = useQuery<todo, todoVariables>(["GET_TODO", id], () =>
    GET_TODO(id)
  )
  const createTodo = useMutation(CREATE_TODO, {
    onSuccess: () => {
      todos.refetch()
    },
  })
  const updateTodo = useMutation(UPDATE_TODO, {
    onSuccess: () => {
      todos.refetch()
    },
  })
  const deleteTodo = useMutation(DELETE_TODO, {
    onSuccess: () => {
      todos.refetch()
    },
  })

  return {
    todo,
    todos,
    createTodo,
    deleteTodo,
    updateTodo,
  }
}
